function docPrint() {
    setPrintDate();
    document.body.offsetHeight;window.print();
}

function setPrintDate() {
    var datetag = document.getElementById("tagprinted");
    if (datetag == null) return;
    
    var currentTime = new Date()
    var month = currentTime.getMonth() + 1
	var day = currentTime.getDate()
	var year = currentTime.getFullYear()
	datetag.innerHTML = month + "/" + day + "/" + year;
    return;
}